import {
  SETTINGS_REQUEST, SETTINGS_REQUEST_SUCCESS, SETTINGS_REQUEST_FAILED
} from "../actions/settings_actions";


const initialState = {
  shop_name: '',
  company_seller: {
    inn: "",
    kpp: "",
    ogrn: "",
    name: "",
    short_name: "",
    adress: "",
    bik: "",
    bank_name: "",
    korr_schet: "",
    rass_schet: "",
    email: "",
    director_name: "",
    director_post: "",
    director_footing: ""
  },
  color: '',
  sharp_corners: false,
  show_available_products: false,
  plug: false,
  max_prod_in_cart: 20,
  max_prod_in_fav: 20,
  requestProgress: false,
  requestFailed: false,
}

export const settingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SETTINGS_REQUEST: {
      return {
        ...state,
        requestProgress: true,
        requestFailed: false
      }
    }
    case SETTINGS_REQUEST_SUCCESS: {
      return {
        ...state,
        shop_name: action.shop_name,
        company_seller: {
          ...state.company_seller,
          inn: action.company_seller.inn,
          kpp: action.company_seller.kpp,
          ogrn: action.company_seller.ogrn,
          name: action.company_seller.name,
          short_name: action.company_seller.short_name,
          adress: action.company_seller.adress,
          bik: action.company_seller.bik,
          bank_name: action.company_seller.bank_name,
          korr_schet: action.company_seller.korr_schet,
          rass_schet: action.company_seller.rass_schet,
          email: action.company_seller.email,
          director_name: action.company_seller.director_name,
          director_post: action.company_seller.director_post,
          director_footing: action.company_seller.director_footing
        },
        color: action.color,
        sharp_corners: action.sharp_corners,
        show_available_products: action.show_available_products,
        plug: action.plug,
        max_prod_in_cart: action.max_prod_in_cart,
        max_prod_in_fav: action.max_prod_in_fav,
        requestProgress: false,
        requestFailed: false
      }
    }
    case SETTINGS_REQUEST_FAILED: {
      return {
        ...state,
        requestProgress: false,
        requestFailed: true
      }
    }
    default: return state;
  }
}
